// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_1Q3wdQQiYz","notification":"_3xnoE0mqoR"};
    if(module.hot) {
      // 1597843259614
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  